<div class="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/3 md:p-6">
  <h3 class="text-base font-semibold text-gray-800 dark:text-white/90">Latest Synchronizations</h3>
  <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Most recent sync per environment pair</p>

  @if (loading()) {
    <div class="flex h-32 items-center justify-center">
      <svg class="h-6 w-6 animate-spin text-blue-500" viewBox="0 0 24 24" fill="none"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/></svg>
    </div>
  } @else if (error()) {
    <p class="mt-4 rounded-lg border border-red-200 bg-red-100 p-3 text-sm text-red-600">{{ error() }}</p>
  } @else {
    <div class="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-3">
      @for (row of rows; track row.source + '-' + row.destination) {
        <div class="rounded-lg border border-gray-100 p-3 dark:border-gray-800">
          <div class="flex items-center justify-between gap-2">
            <span class="text-sm font-semibold text-gray-800 dark:text-white/90">{{ row.source | uppercase }} &rarr; {{ row.destination | uppercase }}</span>
            @if (row.latest) {
              <span class="text-xs text-gray-400">{{ row.latest.generatedOn | date:'yyyy-MM-dd HH:mm' }}</span>
            }
          </div>
          <div class="mt-2 flex flex-wrap gap-1">
            @if (row.latest; as item) {
              @for (entity of entitiesFor(item); track entity) {
                @let status = entityStatus(item, entity);
                <span class="rounded-full px-2 py-0.5 text-xs"
                  [class.bg-green-100]="status === 'complete'" [class.text-green-700]="status === 'complete'"
                  [class.bg-red-100]="status === 'failed'" [class.text-red-700]="status === 'failed'"
                  [class.bg-gray-100]="status === 'skipped'" [class.text-gray-500]="status === 'skipped'"
                  [class.bg-blue-100]="status === 'in-progress'" [class.text-blue-700]="status === 'in-progress'">
                  {{ formatEntity(entity) }}
                </span>
              }
            } @else {
              <span class="text-xs text-gray-400">No synchronization yet</span>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
